import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import wellnessRewardsLogo from '../../assets/wellness/wellness-rewards-logo.png'

import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import StartPointScaleTwo from './components/StartPointScale/StartPointScaleTwo'
import { Link, useHistory } from 'react-router-dom'
import { fetchAutoShipData, fetchPointsData } from '../../redux/actions/redemptionActions'
import { handleRedirect } from '../../redux/actions/appActions'
import moment from 'moment'
import { FormattedMessage, FormattedDate, FormattedNumber } from 'react-intl'
import Modal from '../global-components/Modal'

const cardWrapperStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '300px',
  color: 'var(--zls-primary-surface)',
}

const Dashboard = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { token, repId, user } = useSelector((state) => state.app)
  const { availableAmount, lifetimeAmount, autoShipProfiles, totalVolume, pointsValid, maxMonthlyRedemptionAmount, balanceRealTime } = useSelector((state) => state.redemption)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    document.title = 'Zilis Wellness Redemption - Dashboard'
  }, [])

  useEffect(() => {
    dispatch(fetchPointsData(repId, token))
    dispatch(fetchAutoShipData(repId, token))
  }, [repId, token])

  const autoShipDate = autoShipProfiles.length > 0 && moment(autoShipProfiles[0].nextShipDate)
  const ssoToCloud = () => {
    dispatch(handleRedirect('Cloud'))
  }

  const handleValidatePoints = () => {
    if (!pointsValid) {
      setShowModal(true)
    } else {
      history.push('redeem')
    }
  }

  const toggleModal = (modalState) => {
    setShowModal(modalState)
  }

  const AutoShipMessage = () => {
    return (
      <div>
        <p>
          <FormattedMessage id='dashboard.bv-total-msg' values={{ bv: <FormattedNumber value={totalVolume}></FormattedNumber>, date: autoShipDate && <FormattedDate value={autoShipDate} month='long' day='numeric'></FormattedDate> }} />
        </p>
        <p>
          <FormattedMessage id='dashboard.next-run-date-msg' values={{ date: autoShipDate && <FormattedDate value={autoShipDate} month='long' day='numeric'></FormattedDate> }} />
        </p>
      </div>
    )
  }

  const AutoShipUserRewardsCard = () => {
    return (
      <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '80%', width: '100%', textAlign: 'center' }}>
          <h3>
            <FormattedMessage id='dashboard.available-earnings' />
          </h3>
          <p style={{ fontSize: 'clamp(18px,1.2vw,22px)', margin: 0 }}>
            <FormattedMessage id='dashboard.starpoints-available-msg' values={{ amount: availableAmount }} />
          </p>
          <p style={{ fontSize: '18px', margin: 0 }}>
            <FormattedMessage id='dashboard.realtime-starpoint' values={{ balance: balanceRealTime }} />
          </p>
          <p style={{ fontSize: '12px', margin: 0, maxWidth: '300px' }}>
            <FormattedMessage id='dashboard.starpoint-max-points' values={{ maxAmount: maxMonthlyRedemptionAmount }} />
          </p>
        </div>
        <div style={{ justifySelf: 'flex-end' }}>
          <span
            style={{ cursor: 'pointer', textDecoration: 'underline', textTransform: 'uppercase', fontSize: '24px' }}
            to='redeem'
            onClick={() => {
              handleValidatePoints()
            }}
          >
            <FormattedMessage id='dashboard.redeem' />
          </span>
        </div>
      </div>
    )
  }

  const AutoShipHistoryCard = () => {
    return (
      <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div style={{ height: '80%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <div style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '80%' }}>
            <h3>
              <FormattedMessage id='dashboard.starpoint-history' />
            </h3>
            <p style={{ fontSize: '22px' }}>
              <FormattedMessage id='dashboard.starpoints-earned' values={{ amount: lifetimeAmount }} />
            </p>
          </div>
        </div>
        <div style={{ justifySelf: 'flex-end' }}>
          <Link to='history' style={{ cursor: 'pointer', textDecoration: 'underline', textTransform: 'uppercase', fontSize: '24px', color: 'var(--zls-primary-surface)' }}>
            <FormattedMessage id='dashboard.view' />
          </Link>
        </div>
      </div>
    )
  }

  return (
    <OuterContainer>
      <Modal showModal={showModal} toggleModal={toggleModal} navigateTo={'redeem'} message={'dashboard.max-startpoint-modal'} />
      <DashContainer>
        <HeaderContainer>
          <img alt='Wellness Rewards' src={wellnessRewardsLogo} />
        </HeaderContainer>
        <AutoshipHeaderText>
          {user && user.firstName !== '' && (
            <GreetingText>
              <FormattedMessage id='dashboard.welcome-msg' values={{ name: user.firstName }} />
            </GreetingText>
          )}
          {autoShipDate && <AutoShipMessage />}
          {!autoShipDate && (
            <p>
              <FormattedMessage id='dashboard.no-autoship-msg' values={{ a: (chunks) => <ExternalLink onClick={ssoToCloud}>{chunks}</ExternalLink> }} />
            </p>
          )}
        </AutoshipHeaderText>
        {/* {autoShipDate && ( */}
        {true && (
          <CustomContainer fluid>
            <CustomRow>
              {/* Available earnings card */}
              <Col lg={5} md={12}>
                <Card>
                  <AutoShipUserRewardsCard />
                </Card>
              </Col>

              {/* Star Point history card */}
              <Col lg={5} md={12}>
                <Card>
                  <AutoShipHistoryCard />
                </Card>
              </Col>
            </CustomRow>
          </CustomContainer>
        )}

        <Container fluid>
          <Row>
            <Col lg={12}>
              <DashReminderTextRight>
                <span style={{ fontSize: '24px', color: 'var(--zls-primary-surface)', fontStyle: 'italic', fontWeight: 400 }}>
                  <FormattedMessage
                    id='dashboard.update-autoship-banner-2'
                    values={{
                      a: (chunks) => (
                        <ExternalLink style={{ textDecoration: 'underline', fontSize: '24px', color: 'var(--zls-primary-surface)', fontStyle: 'italic', fontWeight: 400 }} onClick={ssoToCloud}>
                          {chunks}
                        </ExternalLink>
                      ),
                    }}
                  />
                </span>
              </DashReminderTextRight>
            </Col>
          </Row>
        </Container>
        <StartPointScaleTwo />
      </DashContainer>
    </OuterContainer>
  )
}

const CustomContainer = styled(Container)`
  padding: 0;

  @media (max-width: 595px) {
    padding: 15px;
  }
`

const ExternalLink = styled.div`
  color: blue;
  display: inline-block;
  cursor: pointer;
`

const DashReminderTextRight = styled.div`
  display: flex;
  font-weight: bold;
  font-size: 30px;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const Card = styled.div`
  background-color: #fff;
  border: 4px solid var(--zls-primary-surface);
  box-shadow: 0px 3px 6px #00000029;
  margin: 30px 10px;
  color: var(--zls-primary-surface);
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;

  &:hover {
    .off-hover-view {
      display: none;
      opacity: 0;
    }
    .on-hover-view {
      display: flex;
      opacity: 1;
    }
  }

  .off-hover-view {
    display: flex;
    opacity: 1;
    transition: all 0.2s ease-in-out;
  }
  .on-hover-view {
    display: none;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }

  .content {
    padding: 15px;
    text-align: left;

    h3 {
      color: #0f4b8f;
      text-align: left;
      margin: 0;
      font-size: 24px;
    }

    p {
      margin: 10px 0;
      font-weight: bold;
    }

    a {
      text-decoration: underline;
    }
  }
  @media (max-width: 1200px) {
    width: 300px;
  }

  @media (max-width: 992px) {
    margin: 20px 0;
    width: 100%;
  }

  @media (max-width: 768px) {
    h3,
    .content {
      text-align: center !important;
    }
  }
`

const OuterContainer = styled(Container)`
  @media (max-width: 768px) {
    padding: 0 5px;
  }
`

const DashContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`

const HeaderContainer = styled.div`
  display: flex;

  img {
    max-width: 350px;
    width: 100%;
  }

  @media (max-width: 992px) {
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`

const AutoshipHeaderText = styled.div`
  text-align: left;

  p {
    font-size: 24px;
    margin: 10px;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
`

const GreetingText = styled.p`
  font-size: 30px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`

const ColWrapper = styled(Col)`
  text-align: center;

  @media (max-width: 992px) {
    padding: 2%;
  }
`

const CustomRow = styled(Row)`
  justify-content: center;
  gap: 50px;

  @media (max-width: 992px) {
    gap: 10px;
  }
`

export default Dashboard
